import { ServiceBase } from '../../../../../core/services/ServiceBase'
import CategoryProxy from './CategoryProxy'

class CategoryService extends ServiceBase {
  postCategoryCheckData(params) {
    return this.getData(() => CategoryProxy.postCategoryCheckData(params))
  }
}

export default new CategoryService()
